import { jsx as _jsx } from "react/jsx-runtime";
import { LiteralBase, getLiteralBaseProps, baseEditableOptions } from "./TextLiteral";
import { FormattedDate } from "react-intl";
import { identityRecordOfFieldEditorOptions } from "@ploy-ui/form-fields";
export const DatePickerLiteral = ({ localeMatcher, weekday, era, year, month, day, hour, minute, second, timeZoneName, formatMatcher, hour12, timeZone, format, ...rest }) => {
    const formatOptions = {
        localeMatcher,
        formatMatcher,
        timeZone,
        hour12,
        weekday,
        era,
        year,
        month,
        day,
        hour,
        minute,
        second,
        timeZoneName,
        format
    };
    return (_jsx(LiteralBase, { ...getLiteralBaseProps(rest), children: rest.field.value ? (_jsx(FormattedDate, { value: rest.field.value, ...formatOptions, dateStyle: "short" })) : (_jsx("div", {})) }));
};
export const EditorDatePickerLiterals = identityRecordOfFieldEditorOptions({
    DatePickerLiteral: {
        editableOptions: {
            ...baseEditableOptions
        }
    }
});
//# sourceMappingURL=DatePickerLiteral.js.map